import { render } from "./TeacherAttend.vue?vue&type=template&id=24e1ccc0&scoped=true"
import script from "./TeacherAttend.vue?vue&type=script&lang=js"
export * from "./TeacherAttend.vue?vue&type=script&lang=js"

import "./TeacherAttend.vue?vue&type=style&index=0&id=24e1ccc0&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e1ccc0"]])

export default __exports__